module.exports = __webpack_public_path__ + "static/media/col2.87617ccd.svg";